import CollapsibleFormList from './CollapsibleFormList'

export default CollapsibleFormList



// WEBPACK FOOTER //
// ./src/app/modules/CollapsibleFormList/index.js